module.exports = __webpack_public_path__ + "static/media/pdf.85c2ce9f.svg";